import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Aligner } from '@alfa-bank/site-aligner';
import { TextMobile as Text } from '@alfa-bank/site-text-v2/mobile';

import { Heading as Component } from '../heading';
import type { IDeps, THeading } from '../models';

export const HeadingDesktop = createWidget<IDeps, THeading>({
    Aligner,
    Text,
})(Component);
